/* src/app/features/leilao/leilao-lote/leilao-lote.component.scss */
.bold {
  font-weight: bold;
}
.container-alert {
  margin-top: 10em;
}
/*# sourceMappingURL=leilao-lote.component.css.map */
